import App from "antd/es/app";

export const useNotification = () => {
  const { notification } = App.useApp();

  return notification;
};
